<!--
  @description: 组织架构 - 组织管理
  @creator: lwd
  @date: 2021/03/15
-->
<template>
  <div class="organization-management">
    <!-- S 组织架构树 -->
    <div class="common-bg om_tree">
      <!--  -->
      <div v-if="tabList.length > 1">
        <x-swiper class="om_tree_tab" ref="swiper" num="3" :nav="tabList.length > 3">
          <div @click="tabClick(item)" v-for="(item, i) in tabList" :key="item.value" class="tab-item swiper-slide"
            :class="{ active: tabActiveIndex === item.value }">
            <img :class="['arrow', 'arrow' + i]" src="~_img/common/arrow2.png" alt="" />
            <span :class="['label', { 'm-label': item.label.length > 6 }]">{{ item.label }}</span>
          </div>
        </x-swiper>
      </div>
      <div class="om_tree_list">
        <div class="organ-query">
          <IviewInput v-model="queryForm.groupName" @input="organInput" clearable placeholder="搜索组织" />
          <img v-if="isAddOrgan && tabActiveIndex != tabList.slice(-1)[0].value" class="img1"
            src="~_img/organ/add-organ.png" alt="" @click="openDialog('添加组织', {})" />
        </div>

        <Tree :data="treeDataList" :render="renderContent" class="demo-tree-render" @on-select-change="treeClick"></Tree>
      </div>
    </div>
    <!-- E 组织架构树 -->

    <!-- S 组织架构表格 -->
    <div class="common-bg om_table">
      <div class="op_table_action">
        <IviewButton type="primary" @click="openDialog('添加用户', {})" v-if="$permission('organM-addUser') && aiShow">
          <Icon type="md-add" />
          添加
        </IviewButton>
        <div class="query-table">
          <IviewSelect placeholder="请选择账号范围" :optionList="scopeOption" @on-change="searchTable" clearable
            v-model="searchForm.thisAndBelow"></IviewSelect>
          <IviewInput v-model="searchForm.userName" placeholder="请输入账号" @input="searchTable" clearable></IviewInput>
          <IviewInput v-model="searchForm.displayName" placeholder="请输入姓名" @input="searchTable" clearable></IviewInput>
        </div>
      </div>
      <div class="op_table_box">
        <IviewTable :data="tableData" :columns="tableCol" :page="pager" @on-page-change="changePageSize">
          <ul class="table-cao" slot="cao" slot-scope="{ row }">
            <li @click="openDialog('分享登录密码', row)" v-if="$permission('organM-shareInfo') && aiShow">
              分享登录密码
            </li>
            <li @click="openDialog('编辑', row)" v-if="$permission('organM-putUser')">编辑</li>
            <li @click="openDialog('详情', row)">详情</li>

            <el-popover placement="bottom" trigger="hover" popper-class="width-auto">
              <li slot="reference" v-if="($permission('organM-resetPass') || $permission('organM-putUserStatus')) && aiShow">
                更多<i class="iconfont i-xiangxiajiantou"></i>
              </li>
              <div class="table-coll">
              <li v-if="$permission('organM-resetPass') && aiShow" @click="openDialog('重置密码', row)">重置密码</li>
              <li @click="openDialog('禁用', row)" v-if="$permission('organM-putUserStatus') && aiShow">
                {{ row.enable ? '禁用' : '启用' }}
              </li>
              <!-- <li
                  class="del"
                      v-if="$permission('organM-delUser') && aiShow && !row.enable"
                      @click="openDialog('删除', row)"
                    >
                      删除
                    </li> -->
              </div>
            </el-popover>
          </ul>
        </IviewTable>
      </div>
    </div>
    <!-- E 组织架构表格 -->

    <!-- S 添加编辑部门 -->
    <addCompay v-model="depPopup" :form="depForm" :title="ppType == 'add' ? '添加部门' : '编辑部门'" @confirm="depConfirm" />

    <!-- 添加编辑组织 -->
    <AddOrgan v-if="organPopup" v-model="organPopup" :data="organForm" :ppType="ppType"
      :title="ppType == 'add' ? '添加组织' : '编辑组织'" @refresh="getOrganData" />

    <!-- 添加用户 -->
    <AddUser v-if="userPopup" v-model="userPopup" :ppType="ppType" :form="userForm" :depData="currentDepData.topData"
      @refresh="getTreeData" />

    <!-- 确认框 -->
    <IviewModal title="提示" type="confirm" v-model="showCheckModal.visible" :confirmText2="'是否继续进行删除操作？'" @on-ok="checkOk"
      @on-cancel="showCheckModal.visible = false">
    </IviewModal>
    <!-- 分享登录密码 -->
    <IviewModal title="登录信息" type="confirm" closable v-model="lookPassPopup">
      <template slot="footer">
        <IviewButton type="primary" @click="copyPass"> 仅复制登录密码</IviewButton>
        <IviewButton type="primary" @click="copyAll"> 复制全部</IviewButton>
      </template>
      <ul class="user-info" v-if="userInfo">
        <li>
          <div class="t1">姓名:</div>
          <div class="t2">{{ userInfo.displayName }}</div>
        </li>
        <li>
          <div class="t1">登录地址:</div>
          <div class="t2">{{ userInfo.ip }}</div>
        </li>
        <li>
          <div class="t1">登录账号:</div>
          <div class="t2">{{ userInfo.userName }}</div>
        </li>
        <li>
          <div class="t1">登录密码:</div>
          <div class="t2" id="pass">{{ userInfo.password }}</div>
        </li>
      </ul>
    </IviewModal>
    <IviewModal title="登录信息" type="confirm" v-model="resetPassPopup" @on-ok="resetPass"
      @on-cancel="resetPassPopup = false" confirmText2="是否重置密码?">
    </IviewModal>
    <IviewModal title="修改用户状态" type="confirm" v-model="enablePopup" @on-ok="isEnableUser" @on-cancel="enablePopup = false"
      :confirmText2="`是否${currentTableData.enable ? '禁用' : '启用'}该用户?`">
    </IviewModal>
    <IviewModal title="删除用户" type="confirm" v-model="delPopup" @on-ok="delUser" @on-cancel="delPopup = false"
      confirmText2="是否删除该用户?" />
    <UserDetail :data="currentTableData" v-model="lookUserPopup" :top="currentDepData.topData" />
  </div>
</template>
<script>
import { handleCopy, debounce } from '@/utils'
import { getUserInfo, loginMethod } from '@/utils/common'
import { cols, textBtns } from '_u/table'
import addCompay from './modules/addCompay.vue'
import AddUser from './modules/addUser.vue'
import UserDetail from './modules/userDetail.vue'
import AddOrgan from './modules/addOrgan.vue'
import { transitionData } from '@/utils'
export default {
  name: 'organization-management',
  components: { addCompay, AddUser, UserDetail, AddOrgan },
  provide() {
    return {
      config: this.config
    }
  },
  data() {
    return {
      config: {
        //角色管理查询参数
        id: '',
        orgLevel: '',
        groupId: '',
        depTree: []
      },
      scopeOption: [
        { label: '可看所选部门及以下', value: 1 },
        { label: '仅看所选部门', value: 0 }
      ],
      userInfo: null,
      roleShow: false,
      organOption: [],
      searchForm: {},
      depForm: {
        organ: '平台组织',
        upDep: '',
        title: ''
      },
      userForm: {
        userName: '',
        mobile: '',
        email: '',
        depId: '',
        role: []
      },
      organForm: {},
      // 查询组织
      queryForm: {
        groupName: '',
        parentGroupId: ''
      },
      tabActiveIndex: 1,
      treeId: 0,
      treeDataList: [],
      tableCol: [
        ...cols([
          [
            '账号',
            'userName',
            {
              width: 130
            }
          ],
          ['姓名', 'displayName'],
          ['手机号码', 'mobile', { width: 130 }],
          ['角色权限', 'roleName'],
          [
            '状态',
            'status',
            {
              render: (h, p) => {
                let { enable } = p.row
                return h('div', {}, [
                  h(
                    'div',
                    {
                      class: 'table_tr_status'
                    },
                    [
                      h('div', {
                        class: ['tts_box', enable ? 'start' : 'stop']
                      }),
                      h(
                        'div',
                        {
                          class: [enable ? 'text_start' : 'text_stop']
                        },
                        enable ? '使用中' : '已禁用'
                      )
                    ]
                  )
                ])
              }
            }
          ],
          ['创建时间', 'startTime']
        ]),
        {
          title: '操作',
          width: 270,
          align: 'center',
          slot: 'cao'
        }
      ],
      tableData: [],
      pager: {
        current: 1,
        total: 0,
        pageSize: 10
      }, // 表格页码
      resetPassPopup: false,
      lookPassPopup: false,
      lookUserPopup: false,
      organPopup: false,
      depPopup: false,
      userPopup: false,
      enablePopup: false,
      delPopup: false,
      organPopup: false,
      ppType: 'add',
      showCheckModal: {
        visible: false,
        type: ''
      },
      currentDepData: {},
      currentTableData: {},
      tabList: [{ name: '平台组织', value: 1 }],
      aiShow: true,
      isAddOrgan: true
    }
  },
  async created() {
    this.$api.config.getNode({ scopeOrg: 1 }).then((res) => {
      this.tabList = res.data.map((item) => ({ label: item.orgLevelName, value: item.orgLevel }))
      this.tabActiveIndex = this.tabList[0]?.value
      this.config.orgLevel = this.tabActiveIndex
      this.$nextTick(() => this.$refs.swiper.update())
      this.getOrganData()
    })
    // 单点登录隐藏按钮
    this.aiShow = await loginMethod(this.$root.platform)
    // 是否可以编辑组织
    this.$api.config.getNodePermission().then((res) => {
      this.isAddOrgan = Boolean(res.data.addGroupFlag)
    })
  },
  methods: {
    tabClick(item) {
      this.tabActiveIndex = item.value
      this.config.orgLevel = this.tabActiveIndex
      this.getOrganData(item.value)
    },
    treeClick(data, node) {
      let topData = this.treeDataList[node.currentIndex]
      this.currentDepData = { ...node, topData }
      this.userForm.groupId = node.id
      this.config.groupId = node.id
      this.getTreeData({ queryType: 1 }, node.id)
    },
    // 获取对应树的用户数据
    getTreeData(params = {}, id) {
      if (!id) id = this.currentDepData.id
      this.$api.role
        .getUser(
          {
            pageSize: 10,
            pageNum: 1,
            ...this.searchForm,
            ...params,
            orgLevel: this.tabActiveIndex,
            queryType: 1
          },
          [id]
        )
        .then(({ data }) => {
          this.tableData = data.records
          this.pager.total = data.total
          this.tableData.map((item) => {
            item.roleName = item.roleInfo ? item.roleInfo.map((item) => item.roleName).join(', ') : []
            item.role = item.roleInfo ? item.roleInfo.map((item) => item.id) : []
            item.groupId = item.groupInfo[0]?.id
            item.depId = ''
            item.depName = item.groupInfo[0]?.path
            // item.depName = this.currentDepData.path
          })
        })
    },
    // 获取组织树数据
    async getOrganData(params = {}) {
      let userInfo = await getUserInfo()
      let id = (userInfo.currentGroup || {}).id
      await this.$api.organ.getOrganTree2({ ...params, orgLevel: this.tabActiveIndex }, [id]).then((res) => {
        let data = res.data.treeList
        this.organOption = res.data.parentList.map((item) => ({ label: item.title, value: item.id }))
        if (data.length == 0) {
          this.treeDataList = []
          this.tableData = []
          return
        }
        this.config.groupId = data[0].id
        this.config.topId = data[0].parentId
        this.treeDataList = this.$u.tree.handleTreeNode(data, (node) => {
          node.value = node.id
          node.expand = true
          node.lavel = 1
          node.selected = false
        })
        this.treeDataList = this.treeDataList.map((item) => ({
          ...item,
          lavel: 0 //最上层不能编辑和删除
        }))
        // 为树添加下标
        this.treeDataList = transitionData(
          this.treeDataList,
          { currentIndex: true, children: 'children' },
          { isAll: true }
        )
        this.config.depTree = this.treeDataList
        this.treeDataList[0].selected = true
        let topData = data[0]
        this.currentDepData = { ...data[0], topData }
        this.userForm.groupId = data[0].id
        this.getTreeData({}, data[0].id)
      })
      // const add
    },
    // 切换组织
    orangChange(orgLevel) {
      let data = this.sliceTabList.find((item) => item.value == orgLevel)
      this.tabClick(data)
      this.$set(this.tabList, 1, data)
    },
    searchTable(val) {
      debounce(() => {
        this.pager = {
          current: 1,
          pageSize: 10
        }
        this.getTreeData()
      }, 500)
    },
    // 添加编辑部门
    depConfirm(form) {
      let { id } = this.currentDepData
      if (this.ppType == 'add') {
        this.$api.organ
          .addDep({
            orgLevel: this.tabActiveIndex,
            parentId: form.upDep,
            title: form.title,
            groupType: 2
          })
          .then((res) => {
            this.$Message.success('添加成功')
            this.depPopup = false
            this.getOrganData()
          })
      } else {
        this.$api.organ
          .putDep(
            {
              orgLevel: this.tabActiveIndex,
              title: form.title
            },
            [id]
          )
          .then((res) => {
            this.$Message.success('修改成功')
            this.depPopup = false
            this.getOrganData()
          })
      }
    },
    // 删除用户
    delUser() {
      this.$api.user.delUser({}, [this.currentTableData.id]).then((res) => {
        this.$Message.success('操作成功')
        this.getTreeData()
        this.delPopup = false
      })
    },
    // 复制信息
    copyAll(e) {
      let { displayName, ip, userName, password } = this.userInfo
      let value = `
    姓名:${displayName},
    登录地址:${ip},
    登录账号:${userName},
    登录密码:${password}
    `
      handleCopy(value, e, () => {
        this.$Message.success('复制全部成功')
      })
      this.lookPassPopup = false
    },
    copyPass(e) {
      let value = this.userInfo.password
      handleCopy(value, e, () => {
        this.$Message.success('复制密码成功')
      })
      this.lookPassPopup = false
    },
    resetPass() {
      this.$api.organ.resetPass({}, [this.currentTableData.id]).then((res) => {
        this.$Message.success('操作成功')
        this.resetPassPopup = false
      })
    },
    isEnableUser() {
      let { enable, id } = this.currentTableData
      this.$api.organ.putUser({ enable: !enable }, [id]).then((res) => {
        this.$Message.success('操作成功')
        this.enablePopup = false
        this.getTreeData()
      })
    },
    changePageSize(e) {
      this.getTreeData(e)
    },
    openDialog(label, row) {
      this.currentTableData = row
      if (label == '分享登录密码') {
        this.lookPassPopup = true
        this.$api.organ.getPass({}, [row.id]).then((res) => {
          this.userInfo = res.data
          this.userInfo.ip = location.origin
        })
      } else if (label == '重置密码') {
        this.resetPassPopup = true
      } else if (label == '启用' || label == '禁用') {
        this.enablePopup = true
      } else if (label === '编辑') {
        this.userPopup = true
        this.ppType = 'edit'
        this.userForm = JSON.parse(JSON.stringify(row))
      } else if (label == '删除') {
        this.delPopup = true
      } else if (label == '详情') {
        this.lookUserPopup = true
      } else if (label == '添加组织') {
        this.ppType = 'add'
        this.organPopup = true
        this.organForm = {}
      } else if (label == '添加用户') {
        this.ppType = 'add'
        this.userPopup = true
        this.userForm = {}
      }
    },
    renderContent(h, { root, node, data }) {
      let arr = []
      if (this.aiShow && this.$permission('organM-putDep')) {
        if (data.lavel == 0) {
          this.isAddOrgan && arr.push(h(...this.returnSetting(h, '编辑组织', 'btn-edit', node)))
        } else {
          arr.push(h(...this.returnSetting(h, '编辑部门', 'btn-edit', node)))
        }
      }
      if (this.aiShow && this.$permission('organM-delDep')) {
        if (data.lavel == 0) {
          this.isAddOrgan && arr.push(h(...this.returnSetting(h, '删除组织', 'btn-del', node)))
        } else {
          arr.push(h(...this.returnSetting(h, '删除部门', 'btn-del', node)))
        }
      }
      return h(
        'span',
        {
          style: {
            display: 'inline-block',
            width: '100%'
          }
        },
        [
          // icon + 标题 <Icon type="md-folder" />
          h(
            'span',
            {
              style: {
                display: 'inline-flex',
                'align-items': 'center'
              }
            },
            [
              h('Icon', {
                class: 'i-icon i-org',
                style: {
                  marginRight: '5px'
                }
              }),
              h('span', data.title)
              // h('span', data.id)
            ]
          ),
          // 操作按钮
          h(
            'span',
            {
              transfer: true,
              style: {
                display: 'inline-block'
              }
            },
            [
              this.$permission('organM-role') &&
              data.groupType == 1 &&
              h(...this.returnSetting(h, '角色权限设置', 'btn-set', node)),
              this.aiShow &&
              this.$permission('organM-addDep') &&
              h(...this.returnSetting(h, '添加部门', 'btn-add', node)),
              ...arr
            ]
          )
        ]
      )
    },
    append(data) {
      const children = data.children || []
      children.push({
        title: 'appended node',
        expand: true
      })
      this.$set(data, 'children', children)
    },
    remove(root, node, data) {
      const parentKey = root.find((el) => el === node).parent
      const parent = root.find((el) => el.nodeKey === parentKey).node
      const index = parent.children.indexOf(data)
      parent.children.splice(index, 1)
    },
    returnSetting(h, text, icon = '', node) {
      let methodsKey = {
        角色权限设置: 'setRolePerm',
        添加部门: 'addDepartment',
        编辑部门: 'editDepartment',
        删除部门: 'deleteDepartment',
        删除组织: 'deleteDepartment',
        编辑组织: 'editOrgan'
      }
      return [
        'Tooltip',
        {
          props: {
            placement: 'top'
          },
          style: {
            'margin-left': '.75rem'
          },
          class: 'tool_tip'
        },
        [
          h(
            'span',
            {
              on: {
                click: (e) => {
                  e.stopPropagation()
                  if (methodsKey[text]) {
                    this.$nextTick(() => {
                      return this[methodsKey[text]](node)
                    })
                  } else {
                    return null
                  }
                  // return this.setRolePerm(node);
                }
              }
            },
            [
              h('svg-icon', {
                // class: `i-icon ${icon}`,
                props: {
                  'icon-class': `${icon}`
                }
              })
            ]
          ),
          h(
            'span',
            {
              slot: 'content'
            },
            text
          )
        ]
      ]
    },
    // 点击角色权限
    setRolePerm(node) {
      console.log(node)
      this.config.id = node.node.id
      this.config.groupId = node.node.id
      this.config.orgLevel = this.tabActiveIndex
      this.config.orgName = node.node.path
      localStorage.setItem('roleConfig', JSON.stringify(this.config))
      // this.roleShow = true
      let pathArr = this.$route.path.split('/');
      pathArr[pathArr.length - 1] = 'role';
      let path = pathArr.join('/')
      this.$router.push({
        path: path,
        query: { back: true }
      })
    },
    // 添加编辑部门弹框
    addDepartment(node) {
      let { topData } = this.currentDepData
      this.currentDepData = { ...node.node, topData }
      this.depPopup = true
      this.depForm = {
        organ: topData.title,
        upDep: this.currentDepData.id,
        title: ''
      }
      this.ppType = 'add'
    },
    editDepartment(node) {
      let { topData } = this.currentDepData
      this.currentDepData = { ...node.node, topData }
      this.depForm = {
        organ: topData.title,
        upDep: this.currentDepData.parentId,
        title: this.currentDepData.title
      }
      this.depPopup = true
      this.ppType = 'edit'
    },
    // 删除部门
    deleteDepartment(node) {
      this.treeId = node.node.id
      this.showCheckModal.visible = true
      this.showCheckModal.type = 'del'
    },
    // 编辑组织
    editOrgan(node) {
      this.organPopup = true
      this.ppType = 'edit'
      this.organForm = { ...node.node }
    },
    addModalCloseCallBack(type) {
      this[type].visible = false
    },
    // 删除部门
    checkOk() {
      this.showCheckModal.visible = false
      if (this.showCheckModal.type == 'del') {
        this.$api.organ.delDep(null, [this.treeId]).then((res) => {
          this.$Message.success('操作成功')
          this.getOrganData(this.tabActiveIndex)
        })
      }
    },
    // 组织查询
    organInput(val) {
      debounce(() => {
        this.getOrganData({ groupName: val })
      }, 600)
    },
    organChange(val) {
      this.getOrganData({ parentGroupId: val })
    }
  }
}
</script>
<style lang="less" scoped>
.user-info {
  width: 300px;
  margin: 30px auto 0;

  li {
    display: flex;
    line-height: 30px;
    font-size: 16px;

    .t1 {
      width: 80px;
      text-align: right;
      color: #ababab;
    }

    .t2 {
      flex: 1;
      margin-left: 20px;
    }
  }
}
</style>

<style lang="less">
.tool_tip {}

/deep/ .ivu-tooltip-inner {
  min-height: 30px !important;
}

.org_manage_status {
  display: flex;
  justify-content: center;

  .bgbox {
    margin-right: 5px;
    width: 20px;
    height: 20px;

    &.stop {
      background: url(~_img/common/statu-stop.png) center center no-repeat;
      background-size: contain;
      color: #b8321a;
    }

    &.start {
      background: url(~_img/common/statu-start.png) center center no-repeat;
      background-size: contain;
      color: #1ab8a5;
    }
  }

  .text_stop {
    font-size: 14px;
    font-weight: 400;
    color: #b8321a;
  }

  .text_start {
    font-size: 14px;
    font-weight: 400;
    color: #1ab8a5;
  }
}
</style>

<style lang="less" scoped>
.organization-management {
  width: 100%;
  height: calc(100vh - 170px);
  // padding: 20px 30px 30px;
  position: relative;
  .flex-cen();
  align-items: flex-start;

  .om_tree {
    height: 100%;
    width: 429px;
    margin-right: 20px;
    padding: 0;
    display: flex;
    flex-direction: column;

    .om_tree_tab {
      display: flex;
      height: 66px;
      border-bottom: 1px solid #e9e9e9;
      width: 100%;
      padding: 0 16px;

      .tab-item {
        position: relative;
        height: 66px;
        font-size: 16px;
        font-weight: bold;
        cursor: pointer;
        color: #333;
        background: #fff;
        width: 130px;
        margin: 0 2px;
        position: relative;

        .label {
          display: inline-block;
          // max-width: 98px;
          line-height: 66px;
          width: 100px;
          margin-left: 10px;
        }

        .m-label {
          line-height: 24px;
          font-size: 14px;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
        }

        .arrow {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          right: -5px;
          width: 16px;
        }

        .arrow-b {
          width: 15px;
          height: 15px;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          right: -20px;
          cursor: pointer;

          /deep/.i-select {
            z-index: 10;
            position: absolute;
            left: 0;
            top: 0;

            .ivu-select.input-middle {
              width: 15px;
              height: 15px;
            }

            .ivu-select-selection {
              opacity: 0;
              height: 15px;
            }
          }

          img {
            width: 15px;
            position: absolute;
            top: 0;
            left: 0;
          }
        }
      }

      .tab-item:last-child {
        .arrow {
          display: none;
        }
      }

      .active {
        // color: #5572bf;
        color: var(--theme-color);
        font-weight: bold;
      }
    }

    .add-organ {
      margin-top: 10px;
      padding-right: 10px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }

    .om_tree_list {
      padding: 12px 10px 0 30px;
      flex: 1;

      .organ-query {
        display: flex;
        align-items: center;

        .i-input {
          /deep/.ivu-input-wrapper {
            width: 350px;
          }
        }

        .img1 {
          margin-left: 10px;
          cursor: pointer;
          width: 24px;
        }

        // .i-select {
        //   /deep/.ivu-select {
        //     width: 166px;
        //     margin-left: 24px;
        //   }
        // }
      }

      .show-scroll();

      .add-organ {
        display: flex;
        justify-content: flex-end;
      }

      .ivu-tree {
        margin-top: 12px;

        /deep/ .ivu-tree-children {}
      }

      /deep/ .ivu-tree-title {
        width: calc(100% - 30px);
        height: 30px;
        font-size: 14px;
        font-family: PingFang-SC-Heavy, PingFang-SC;
        color: #2c3542;

        >span {
          height: 30px;
          display: inline-flex !important;
          align-items: center;
          justify-content: space-between;
        }

        &:hover {
          background: rgba(var(--theme-color-rgb), 0.1);
        }
      }

      /deep/ .ivu-tree-title-selected {
        background: linear-gradient(90deg,
            rgba(var(--theme-color-rgb), 0.15),
            rgba(var(--theme-color-rgb), 0.08),
            rgba(var(--theme-color-rgb), 0.02));
        color: var(--theme-color);
        font-weight: 800;
      }

      /deep/ .ivu-icon {
        transform: rotate(0);
        width: 16px;
        height: 16px;
      }

      /deep/ .ivu-tree-arrow {
        height: 30px;
        display: inline-flex !important;
        align-items: center;

        i {
          background: #fff;
          box-shadow: inset 0px 0px 3px 1px #cad7fa;
          border-radius: 4px;
        }
      }

      /deep/ .ivu-tree-arrow-open {
        // f330
        .ivu-icon-ios-arrow-forward:before {
          content: '\F418';
          width: 16px;
          height: 16px;
          font-size: 16px;
        }
      }

      /deep/ .ivu-icon-ios-arrow-forward:before {
        content: '\f330';
        width: 16px;
        height: 16px;
        font-size: 16px;
        color: #1b3f9b;
      }
    }
  }

  .om_table {
    width: calc(100% - 449px);
    height: 100%;
    padding: 20px 20px 0;
    .flex-col();

    .op_table_action {
      margin-bottom: 10px;
      width: 100%;
      display: flex;
      justify-content: space-between;

      .query-table {
        display: flex;
        align-items: center;

        .i-select {
          margin: 0 14px;
        }

        .i-input {
          margin-right: 14px;
        }
      }
    }

    .op_table_box {
      width: 100%;
      height: 100%;

      /deep/.i-table {
        .ivu-table-wrapper {
          height: calc(100vh - 290px);
        }

        .ivu-table-body {
          max-height: calc(100% - 46px);
        }
      }

      /deep/.i-page {
        bottom: 16px;
      }
    }
  }
}

// {
//       .ivu-tabs {
//       height: 64px;
//       /deep/.ivu-tabs-bar {
//         height: 100%;
//         .ivu-tabs-nav-wrap {
//           height: 100%;

//           /deep/.ivu-tabs-nav {
//             .ivu-tabs-tab {
//               background: pink;
//             }
//           }
//         }
//       }
//     }
//     // .ivu-tabs-content,
//     /deep/.ivu-tabs-context-menu {
//       display: none !important;
//     }
//     /deep/.ivu-tabs-content {
//       display: none !important;
//     }
// }
</style>
